import { stateSchema } from "@redotech/redo-model/geographic-unit";
import * as z from "zod/v4";

export const getStates = {
  name: "getStates" as const,
  input: z.object({ countryCode: z.string() }),
  output: z.array(stateSchema),
};
